(function($) {
    $.widget("ca.caFormErrorWidget", {
        options: {errors: []},
        
        _create: function() {
            this.element.on('blur', function () {
                $(this).parents('.ca-element-error-wrapper').find('.ca-error-popup').fadeOut();
            });
        },
        
        open: function() {
            if (this.options.errors.length == 0) {
                return;
            }
            
            var container = this.element.parents('.ca-element-error-wrapper');
            
            if (container.find('.ca-error-popup').length == 0) {
                container.append('<div class="ca-error-popup"><div class="arrow"></div><div class="wrapper">'
                                + '<div class="message"><ul class="errors"></ul></div></div></div>');
            } else {
                container.find('.ca-error-popup ul.errors').html();
            }
            
            var lis = '';
            
            for (var i in this.options.errors) {
                if (typeof this.options.errors[i] === 'string') {
                    lis += '<li>' + this.options.errors[i] + '</li>';
                }
            }
            
            container.find('.ca-error-popup ul.errors').html(lis);
            container.find('.ca-error-popup').show();
        },

        destroy: function () {
            var container = this.element.parents('.ca-element-error-wrapper');
            container.parent().removeClass('has-error');
            container.find('.ca-error-popup').remove();
        }
    });
    
    $.fn.caFormError = function(messages) {
        if (typeof messages === 'string') {
            messages = [messages];
        }
        
        $(this).caFormErrorWidget({errors: messages});
        $(this).caFormErrorWidget('open');
    };
})(jQuery);